import * as Parse from "parse";

import { Options as OpenWareOptions } from "./types";

let API: OpenWareAPI | null = null;
type fetchReturn = [Promise<Response>, () => void];
export function getAPI() {
  if (API === null) {
    throw new Error("OpenWareAPI not initialized");
  }
  return API;
}

export function initAPI(config: OpenWareOptions) {
  API = new OpenWareAPI(config);
}

class OpenWareAPI {
  public config: OpenWareOptions;

  constructor(config: OpenWareOptions) {
    this.config = config;
  }
  public getConfig() {
    return this.config;
  }
  public fetch(path: string, init: RequestInit = {}): fetchReturn {
    const secure = this.config.secure ? "s" : "";
    const host = this.config.host;
    const controller = new AbortController();
    const signal = controller.signal;

    const url = `http${secure}://${host}${path}`;

    const headers = {
      ...(init.headers || {}),
      "OD-SESSION": Parse.User.current().getSessionToken(),
    };
    const cancel = () => controller.abort();
    return [
      fetch(url, {
        ...init,
        signal,
        headers,
      }),
      cancel,
    ];
  }
}
